export const SMART_QUERY_REQUEST = 'SMART_QUERY_REQUEST';
export const SMART_QUERY_SUCCESS = 'SMART_QUERY_SUCCESS';
export const SMART_QUERY_FAILURE = 'SMART_QUERY_FAILURE';

export const smartQueryRequest = (stationId, params) => {
//    console.log('actions : ', SMART_QUERY_REQUEST);

    return {
        type: SMART_QUERY_REQUEST,
        stationId, 
        params,
        result: [],
    }
}

export const smartQuerySuccess = (result) => {
//    console.log('actions : ', SMART_QUERY_SUCCESS, result);
    return {
        type: SMART_QUERY_SUCCESS,
        result: result,
    }
}

export const smartQueryFailure = (error) => {
//    console.log('actions : ', SMART_QUERY_FAILURE);
    return {
        type: SMART_QUERY_FAILURE,
        error,
    }
}
